import { useCallback } from "react"
import { useMutationQueueStore, enqueueMutation, getQueueVersionRef } from "store/mutationQueue.store"

/**
 * Per-entity serialized mutation queue. Callers passing the same `key` share one queue
 * and one `versionRef`, so any code reading `versionRef.current` sees the version
 * written by the preceding mutation. `isPending` is true whenever at least one task is
 * queued or in flight, suitable for disabling action buttons.
 */
export const useEntityMutationQueue = (key: string, initialVersion: number) => {
	const versionRef = getQueueVersionRef(key, initialVersion)
	const isPending = useMutationQueueStore((s) => (s.pendingByKey[key] ?? 0) > 0)

	const enqueue = useCallback(
		<T>(task: () => Promise<T>): Promise<T> => enqueueMutation(key, versionRef.current, task),
		[key, versionRef],
	)

	return { enqueue, versionRef, isPending }
}
